import { memo, useEffect, type FC } from 'react';
import { observer } from 'mobx-react';
import { autorun } from 'mobx';
import { useHistory } from '@compat/router';
import { CPCategoriesList } from './CatalogCategory/components/components';
import { MenuListBarMenu } from '@components/Layout/Header/components/MainHeader/CatalogBtn/CatalogBtnList/components/components';
import { catalogBarBanner } from '@images';
import { useStores } from '@root/src/stores';

const Banner = memo(() => (
  <div
    style={{
      backgroundImage: `url(${catalogBarBanner})`
    }}
    className='sm:bg-130% bg-cover bg-no-repeat bg-center bg-[#DEF4FF] md:h-[119px] sm:h-[60px] w-full h-[160px] rounded-xl overflow-hidden flex items-center justify-center mb-5'
  >
    <div className='text-center'>
      <h2 className=' mb-1 text-2.5xl font-medium md:text-xl md:mb-2 sm:text-xs sm:mb-0 md:leading-tight sm:leading-4'>
        Заказывайте блюда из бара
        <br />
        вместе с товарами из магазина!
      </h2>
      <p className='text-xl md:text-sm sm:text-xxs'>
        Доставим{' '}
        <span className='inline-flex px-1 bg-[#FFEA81]'>
          сегодня от 30 минут
        </span>
      </p>
    </div>
  </div>
));

const CatalogBar: FC = observer(() => {
  const { catalogStore, cartStore } = useStores();
  const { menu } = catalogStore;
  const { isCurrentAddressValidForExpress, isLoadCart } = cartStore;
  const history = useHistory();
  useEffect(() => {
    const disposer = autorun(() => {
      if (isLoadCart && !isCurrentAddressValidForExpress) {
        history.replace('/catalog');
      }
    });
    return () => {
      disposer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const barMenuItem = menu.find(item => item.isBarMenu);
  const filteredMenu = menu.filter(item => {
    if (item.isBarMenu && !isCurrentAddressValidForExpress) {
      return false;
    }
    return true;
  });

  if (!barMenuItem) {
    return null;
  }
  return (
    <div>
      <div className='hidden w-full allMd:block'>
        <Banner />
      </div>
      <div className='grid grid-cols-[15rem,calc(100%-15rem-24px)] gap-x-6 mt-2.5 sm:block mb-10'>
        <div className='sm:hidden'>
          <CPCategoriesList menu={filteredMenu} />
        </div>
        <div className='w-full'>
          <h1 className='block mb-8 text-3xl font-medium sm:text-lg sm:mb-4'>
            {barMenuItem.title}
          </h1>
          <div className='w-full allMd:hidden'>
            <Banner />
          </div>
          <MenuListBarMenu
            list={barMenuItem?.childrenItems || []}
            onClick={() => {}}
            className='grid-cols-[repeat(auto-fill,minmax(171px,1fr))] allMd:grid-cols-[repeat(auto-fill,minmax(151px,1fr))]'
          />
        </div>
      </div>
    </div>
  );
});

export default CatalogBar;
